import styled from 'styled-components';
import { fontWeights } from 'app/styles/variables';

export const HeaderLinksTitle = styled.div`
  margin-bottom: 1rem;
`;

export const HeaderLinksSt = styled.div`
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

export const IndentedLinksSt = styled.div`
  margin-left: 1rem;
  font-size: ${({ theme }) => theme.fontSizes.p2};
  line-height: ${({ theme }) => theme.lineHeights.p2};
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${fontWeights.bold};
`;

interface IndentedLinkStProps {
  indentLevel?: number;
}

export const IndentedLinkSt = styled.div<IndentedLinkStProps>`
  margin-bottom: 0.5rem;
  ${({ indentLevel }) =>
    indentLevel > 0 ? `margin-left: ${indentLevel}rem;` : ''}
`;
